import React, { useState } from 'react';
import jMoment from 'moment-jalaali';
import BookmarkRoundedIcon from '@mui/icons-material/BookmarkRounded';

import { TabContext, TabList, TabPanel } from '@mui/lab';
import { addCommas, digitsFaToEn } from '@persian-tools/persian-tools';
import { NewDialogTitle, NewDialogContent, NewDialogActions } from 'components';
import { Avatar, Box, Card, CardHeader, Stack, Tab, Typography } from '@mui/material';

import Users from './Users';
import Products from './Products';
import AssignUser from './AssignUser';
import AssignProduct from './AssignProduct';
// import ReadyCouponRequest from './ReadyCouponRequest';

export default function Content({ res, refetch, onClose }) {
  const [step, setStep] = useState('1');
  const model = res[0];
  return (
    <>
      {/* <NewDialogTitle title="جزییات بن" onClose={onClose} /> */}
      {/* <NewDialogContent isPopup> */}
        <Stack height={320} p={1} flex={1} rowGap={1} bgcolor="background.paper" overflow="scroll">
          <Model {...model} step={step} setStep={setStep} />
        </Stack>
      {/* </NewDialogContent> */}
      <NewDialogActions>
        {step === '2' && <AssignUser {...model} refetch={refetch} isActive={step === '2'} />}
        {step === '1' && <AssignProduct {...model} refetch={refetch} isActive={step === '1'} />}
        {/* {(model.status === 'PENDING' || model.status === 'REJECTED') && ( */}
          {/* <ReadyCouponRequest id={model.id} refetch={refetch} /> */}
        {/* )} */}
      </NewDialogActions>
    </>
  );
}

function Model({
  id,
  shop,
  type,
  step,
  title,
  users,
  status,
  amount,
  setStep,
  end_date,
  is_active,
  start_date,
  products_shop,
  assignment_type,
  product_categories,
}) {
  return (
    <>
      {/* <Box>
        <Card>
          <CardHeader
            sx={{ p: 1 }}
            avatar={
              <Avatar sx={{ height: 28, width: 28, fontSize: 18, bgcolor: 'action.selected' }}>
                <BookmarkRoundedIcon fontSize="inherit" color="primary" />
              </Avatar>
            }
            title={<Typography variant="subtitle2">{title}</Typography>}
            subheader={
              <Typography variant="caption" color="textDisabled">{`هر نفر ${addCommas(
                Number(amount)
              )} تومان`}</Typography>
            }
            action={
              <Stack rowGap={1}>
                <Typography
                  px={0.5}
                  borderRadius={0.5}
                  variant="caption"
                  color="warning.darker"
                  bgcolor="warning.lighter"
                >{`فروشگاه ${shop?.title}`}</Typography>
                <Typography variant="caption" px={0.5} color="textDisabled">
                  انقضا:
                  <Typography component="span" variant="caption" letterSpacing={0.5}>
                    {digitsFaToEn(jMoment(end_date).format('jYYYY/jMM/jDD'))}
                  </Typography>
                </Typography>
              </Stack>
            }
          />
        </Card>
      </Box> */}
      <UsersAndProducs
        step={step}
        type={type}
        users={users}
        setStep={setStep}
        products={products_shop}
        assignmentType={assignment_type}
        categories={product_categories || []}
      />
    </>
  );
}

function UsersAndProducs({ type, products, categories, users, step, setStep, assignmentType }) {
  const handleChange = (event, newValue) => {
    setStep(newValue);
  };
  return (
    <TabContext value={step}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <TabList variant="fullWidth" onChange={handleChange} aria-label="owners">
          <Tab label="محصولات" value="1" />
          <Tab label="کاربران" value="2" />
        </TabList>
      </Box>
      <TabPanel sx={{ px: 1, py: 2 }} value="1">
        <Products type={type} products={products} categories={categories} assignmentType={assignmentType} />
      </TabPanel>
      <TabPanel sx={{ px: 1, py: 2 }} value="2">
        <Users type={type} users={users} />
      </TabPanel>
    </TabContext>
  );
}
